/* IM FAQ Split — isolated, scoped */
(() => {
  const ROOT_SELECTOR = '[data-im-faq-split]';

  function setItemOpen(item, open) {
    if (!item) return;

    const trigger = item.querySelector(
      '[data-im-faq-trigger]'
    );

    const answer = item.querySelector(
      '[data-im-faq-answer]'
    );

    item.classList.toggle(
      'is-open',
      open
    );

    if (trigger) {
      trigger.setAttribute(
        'aria-expanded',
        open ? 'true' : 'false'
      );
    }

    if (answer) {
      answer.hidden = !open;
    }
  }

  function closeOtherItems(
    root,
    currentItem
  ) {
    root
      .querySelectorAll(
        '[data-im-faq-item]'
      )
      .forEach((item) => {
        if (item === currentItem) {
          return;
        }

        setItemOpen(
          item,
          false
        );
      });
  }

  function bindRoot(root) {
    if (
      !root ||
      root.__imFaqBound
    ) {
      return;
    }

    root.__imFaqBound = true;

    const singleOpen =
      root.getAttribute(
        'data-single-open'
      ) === 'true';

    root
      .querySelectorAll(
        '[data-im-faq-trigger]'
      )
      .forEach((trigger) => {
        trigger.addEventListener(
          'click',
          () => {
            const item =
              trigger.closest(
                '[data-im-faq-item]'
              );

            if (!item) return;

            const isOpen =
              item.classList.contains(
                'is-open'
              );

            const nextOpen =
              !isOpen;

            if (
              singleOpen &&
              nextOpen
            ) {
              closeOtherItems(
                root,
                item
              );
            }

            setItemOpen(
              item,
              nextOpen
            );
          }
        );
      });
  }

  function init() {
    document
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(bindRoot);
  }

  document.addEventListener(
    'DOMContentLoaded',
    init
  );

  document.addEventListener(
    'shopify:section:load',
    init
  );

  document.addEventListener(
    'shopify:section:reorder',
    init
  );

  if (
    document.readyState !==
    'loading'
  ) {
    init();
  }
})();